import { reactive, shallowReadonly } from 'vue'

/**
 * ValidationInspector（開発時のデバッグ表示）向けに ValidationObserver が公開する検査状況
 */
export interface ValidationInspectorEntry {
  namespace: string,
  fields: string[],
  checkedFields: string[],
  inProgress: boolean,
}

const entries = reactive<ValidationInspectorEntry[]>([])

/**
 * 画面内の ValidationObserver の検査状況の一覧
 * @description Observer がマウント時に登録し、アンマウント時に取り下げる。表示専用で、バリデーションの制御には関与しない。
 */
export const validationInspectorRegistry = {
  entries: shallowReadonly(entries),

  add(entry: ValidationInspectorEntry) {
    entries.push(entry)
  },

  remove(entry: ValidationInspectorEntry) {
    const index = entries.indexOf(entry)
    if (index >= 0) entries.splice(index, 1)
  },
}
